<template>
    <div class="slider">
        <main-content />
    </div>
</template>

<script>
import mainContent from '@/components/slider/index.vue'

export default {
    name: 'slider',
    components: {
        mainContent
    }
}
</script>
